import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {  ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom, map, Observable } from 'rxjs';

import { WeblinkFaultService } from './weblink-fault.service';
import { Jwt } from '../shared/jwt/jwt';

@Injectable()
export class CanNavigateToWeblinkGuard implements CanActivate {

  private activeToken: string;

  constructor(private weblinkFaultService: WeblinkFaultService,
    private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const token = next.params['token'];
    const jwt = new Jwt(token);
    if (!token) {
      this.activeToken = null;
      return false;
    } else if (token === this.activeToken) {
      return true;
    } else {
      return firstValueFrom(
        this.weblinkFaultService.isValidToken(token)
          .pipe(
            map(result => {
              if (result) {
                this.activeToken = token;
                return true;
              }
              this.activeToken = null;
              return false;
            })));
    }
  }
}
